import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpInfoModalComponent } from './modals/help-info-modal/help-info-modal.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { InputTextModule } from 'primeng/inputtext';
import { SharedModule } from '../shared/shared.module';
import { FileUploadModule } from 'primeng/fileupload';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { RouterModule } from '@angular/router';
import { DividerModule } from 'primeng/divider';

@NgModule({
  declarations: [HelpInfoModalComponent],

  imports: [
    CommonModule,
    InputTextModule,
    FontAwesomeModule,
    SharedModule,
    FileUploadModule,
    FormsModule,
    TableModule,
    RouterModule,
    DividerModule
  ]
})

export class HelpModule { }
